


































































import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { BSpinner } from "bootstrap-vue";
import { User, Calendar } from "@/store/modules/types";
import { MeasureType } from "@/store/modules/enums";

@Component({
  components: {
    BSpinner,
  },
  computed: mapGetters("auth", ["userMeasureTypes", "userCalendars"]),
})
export default class Login extends Vue {
  username = "";
  password = "";
  userMeasureTypes!: Array<string>;
  userCalendars!: Array<Calendar>;
  async login() {
    const { username, password } = this;
    if (!username || !password) {
      return;
    }
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("auth/login", { username, password });
      if (this.userMeasureTypes.length && this.userCalendars.length) {
        this.$router.push("/");
      } else if (this.userMeasureTypes.length) {
        if (this.userMeasureTypes.length === 1) {
          switch (this.userMeasureTypes[0]) {
            case MeasureType.ADHERENCE:
              break;
            case MeasureType.COMMUNICATION:
              break;
            case MeasureType.DISCHARGE:
              this.$router.push("/discharges");
              break;
            case MeasureType.ELIGIBILITY:
              break;
            case MeasureType.GAP:
              this.$router.push("/gaps");
              break;
            case MeasureType.HEALTH_RISK_ASSESSMENT:
              break;
            case MeasureType.HIGH_COST_HIGH_NEEDS:
              break;
          }
        } else {
          this.$router.push("/");
        }
      } else if (this.userCalendars.length) {
        this.$router.push("/schedule");
      } else {
        this.$router.push("/");
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
      this.password = "";
    }
  }
}
